import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { GButton, GDialog } from '../../'
import { AppButton } from '@clickguard/design-system'
import { useTrackPostHogEvent } from 'utils/posthog'
import { PostHogEvent, PostHogPath } from 'utils/posthog-events'

interface ActivateAccountNoticeProps {
	accountId?: string
}

export const ActivateAccountNotice = ({
	accountId
}: ActivateAccountNoticeProps) => {
	const navigate = useNavigate()
	const [showDemoDialog, setShowDemoDialog] = useState(false)
	const trackPostHogEvent = useTrackPostHogEvent()

	const handleActivate = () => {
		trackPostHogEvent(
			PostHogEvent.NO_SUBSCRIPTION_CTA_ACTIVATE,
			PostHogPath.NO_SUBSCRIPTION,
			null
		)
		if (accountId) {
			navigate(`/start/standard/${accountId}`)
		}
	}

	const handleWatchDemo = () => {
		trackPostHogEvent(
			PostHogEvent.NO_SUBSCRIPTION_CTA_INTERACTIVE_DEMO,
			PostHogPath.NO_SUBSCRIPTION,
			null
		)
		setShowDemoDialog(true)
	}

	useEffect(() => {
		if (showDemoDialog) {
			trackPostHogEvent(
				PostHogEvent.NO_SUBSCRIPTION_START_INTERACTIVE_DEMO,
				PostHogPath.NO_SUBSCRIPTION,
				null
			)
		}
	}, [showDemoDialog, trackPostHogEvent])

	return (
		<>
			<div className="flex items-center w-full">
				<div className="flex items-center justify-between w-full">
					<span className="text-md font-medium text-gray-900">
						This dashboard is displaying demo data. Activate your workspace to
						start using ClickGuard
					</span>
					<div className="flex items-center gap-4">
						<GButton
							onClick={handleWatchDemo}
							color="primary"
							labelClassName="font-medium text-xs sm:text-sm text-gray-900"
							className="rounded-full px-3 py-1.5 sm:px-4 sm:py-2 h-auto bg-t-step-inactive border border-[#554BFD] hover:bg-t-step-inactive"
						>
							Watch interactive demo
						</GButton>
						<AppButton size="sm" label="Activate" onClick={handleActivate} />
					</div>
				</div>
			</div>

			<GDialog
				open={showDemoDialog}
				onClose={() => setShowDemoDialog(false)}
				maxWidth="3xl"
				title="Watch interactive demo"
			>
				<div className="flex items-center justify-center w-full">
					<iframe
						width="100%"
						height="600"
						className="rounded-lg"
						src="https://share.clickguard.com/e/cmluzflcu000dla04303odtfi/tour"
						title="ClickGuard Interactive Demo"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
				</div>
			</GDialog>
		</>
	)
}
